import { IBrand } from '@/modules/common/services/local-storage';
import { ICustomer, IPartnerInfo } from '@/types/models/Customer';

export interface ILoginResponse {
  accessToken: string;
  partnerInfos: IPartnerInfo;
  user: ICustomer;
  brand: IBrand | null;
  isBrandOwner: boolean;
}

export type GetThemeByParamType = 'email' | 'domain';

export interface ICheckSetupTokenResponse {
  email: string;
  isWhiteLabel: boolean;
}

export interface ICommitSetupTokenResponse {
  user: ICustomer;
  accessToken: string;
  refreshToken: string;
}

export interface InstantLoginResponse {
  user: ICustomer;
  brand: IBrand | null;
  accessToken: string;
  refreshToken: string;
}

export interface WootricResponse {
  age: number;
  apiId: string;
  name: string;
  email: string;
  profession: string;
  accountCreatedAt: string;
  birthDate: string;
  ageRange: string;
  sex: string;
  state: string;
  totalBalance: number;
  totalBalanceRange: string;
  patrimony: number;
  patrimonyRange: string;
  computedProfileType: string;
  enableNPSSurvey: boolean;
}

export interface IVerifyEmailTokenRequest {
  hash: string;
  step: string;
}

export interface ICheckResetTokenRequest {
  hash: string;
}

export interface ICommitResetTokenRequest {
  hash: string;
  password: string;
}

export interface IVerifyAccountPasswordRequest {
  password: string;
}

export interface IVerifyAccountPasswordResponse {
  isValid: boolean;
  score: number;
  tip: string;
}

export interface IUnblockTokenRequest {
  hash: string;
  type: string;
}

export interface ICheckSetupTokenRequest {
  hash: string;
}

export interface ICommitSetupTokenRequest {
  hash: string;
  password: string;
}

export interface ILoginRequest {
  email: string;
  password: string;
  token?: string;
}

export interface IChatToken {
  token: string;
}

export interface ResetPasswordRequest {
  email: string;
  token?: string;
}

export interface InstantLoginRequest {
  hash: string;
}

export interface MembershipTermsResponse {
  title: string;
  description: string;
  contracts: Contracts[];
}

interface Contracts {
  code: string;
  title: string;
  description: string;
  action: Actions;
}

interface Actions {
  title: string;
  url: string;
}

export enum RegulatoryUpdateStatus {
  BLOCKED = 'blocked',
  UP_TO_DATE = 'up_to_date',
  ABOUT_TO_BE_BLOCKED = 'about_to_be_blocked'
}

export enum RegulatoryUpdateStatusReason {
  NONE = 'none',
  IN_ANALYSIS = 'in_analysis',
  PENDING_RESIDENCE_PROOF = 'pending_residence_proof'
}

export enum EAccountStatusAction {
  RegisterPersonal = 'register-personal',
  RegisterFinancialLife = 'register-financial-life',
  RegisterDocuments = 'register-documents',
  FacematchRequired = 'facematch-required',
  FacematchRejected = 'facematch-rejected',
  RegisterAddressReview = 'register-address-review',
  RegisterMinorsPending = 'register-minors-pending',
  RegisterRejected = 'register-rejected',
  FacematchError = 'facematch-error',
  RegisterAnalysis = 'register-analysis'
}

export interface RegulatoryUpdateStatusResponse {
  status: RegulatoryUpdateStatus;
  statusReason?: RegulatoryUpdateStatusReason;
}

export interface DepositInformation {
  type: string;
  bank: string;
  agency: string;
  account: string;
}

export interface IAccountStatusStep {
  title: string;
  index: number;
  length: number;
}

export interface IAccountStatus {
  icon: string;
  title: string;
  description: string;
  button?: {
    label: string;
    action: EAccountStatusAction;
    link: string;
  } | null;
  step?: IAccountStatusStep | null;
}

export interface AccountStates {
  clientEnabled: boolean;
  accountStatus: IAccountStatus;
  depositInformation: DepositInformation;
  hasInvestmentProfile: boolean;
}

export interface GetCustomerAccountStatesResponse {
  state: AccountStates;
}
